<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="商标信息"
      edit-title
      id-key="TrademarkId"
      :data="data"
      :line-form="true"
      form-label-width="110px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="商标编码" prop="TrademarkNo">
          <el-input v-model="data.TrademarkNo" placeholder="请输入商标编码" />
        </el-form-item>
        <el-form-item label="商标名称" prop="TrademarkName">
          <el-input v-model="data.TrademarkName" placeholder="请输入商标名称" />
        </el-form-item>

         <el-form-item label="印刷类型" prop="PrintType">
          <el-input v-model="data.PrintType" placeholder="请输入印刷类型" />
        </el-form-item>
        <el-form-item label="印刷颜色" prop="PrintColor">
          <el-input v-model="data.PrintColor" placeholder="请输入印刷颜色" />
        </el-form-item>

        <el-form-item label="商标图片" class="notBottom" prop="TrademarkPhoto">
          <el-upload
            class="file-up"
            :action="host + '/api/Common/UploadPicture'"
            list-type="picture-card"
            :show-file-list="true"
            accept=".jpg,.png,"
            :on-success="
              (res, file, fileList) => {
                onSuccess(res, file, fileList, 'Imgs')
              }
            "
            :headers="headers"
            :file-list="Imgs"
            :limit="3"
            :on-preview="handlePictureCardPreview"
            :on-exceed="onExceed"
            :before-upload="beforePhotoUpload"
            :on-remove="
              (file, fileList) => {
                fileRemove(file, fileList, 'Imgs')
              }
            "
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="序号" prop="Sn">
          <el-input type="number" v-int v-model="data.Sn" style="width: 100px"></el-input>
          <!-- <el-input-number v-model.number="data.Sn" :min="0" step-strictly style="width: 100px" ></el-input-number> -->
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
    <el-dialog :visible.sync="dialogVisible" title="查看图片" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import * as imageConversion from 'image-conversion'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      data: {
        TrademarkId: 0,
        TrademarkNo: '',
        TrademarkName: '',
        TrademarkPhoto: '',
        PrintColor: '',
        PrintType: '',
        Status: 1,
        Sn: null
      },
      formApi: require('@/api/sy/formSetting').default,
      api: require('@/api/ba/trademark').default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        TrademarkNo: [{ required: true, message: '请输入商标编码' }],
        TrademarkName: [{ required: true, message: '请输入商标名称' }],

        Sn: [{ required: true, message: '请输入序号' }]
      },
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      Imgs: [],
      removeImgs: [],
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  computed: {
    host() {
      return window.location.origin
    }
  },
  methods: {
    beforePhotoUpload(file) {
      //const is500k = file.size / 1024 <= 2048;
      // if (!is500k) {
      //   this.$message.error("照片大小不能超过2M");
      // }
      // return is500k;
      var limit = 5
      return new Promise((resolve, reject) => {
        let fileTypeLength = file.name.split('.').length
        if (fileTypeLength > 0) {
          let fileType = file.name.split('.')[fileTypeLength - 1].toLowerCase()
          const extension = fileType === 'jpg'
          const extension2 = fileType === 'png'
          const extension4 = fileType === 'jpeg'
          const isSizeBig = file.size / 1024 / 1024 < limit // 图片大小不超过1M
          if (!extension && !extension2 && !extension4) {
            this.$message.warning(this.salewaynumber == 'en' ? 'Pictures can only be in jpg,jpeg,png format' : '上传图片只能是 JPG、JPEG、PNG 格式!')
            //this.isUpload = false;
            reject(false)
          } else {
            // resolve(file)
            if (isSizeBig) {
              resolve(file)
            } else {
              // this.$message.warning(
              //   `当前图片为${(file.size / 1024 / 1024).toFixed(2)}M，将进行压缩`
              // );
              imageConversion.compressAccurately(file, 1024).then(res => {
                // console.log(res, "aa");
                // this.$message.warning(
                //   `压缩完成大小约为${(res.size / 1024 / 1024).toFixed(2)}M`
                // );
                resolve(res)
              })
            }
          }
        }
      })
    },
    onSuccess(res, file, fileList, name) {
      if (res.Code == 0) {
        this[name].push({ url: '/api' + res.Data, url2: res.Data, T: 0 })
      } else {
        fileList.splice(fileList.length - 1, 1)
        this.$message.error(res.Msg)
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    fileRemove(file, fileList, name) {
      console.log(file, 'move')
      var index = this[name].findIndex(x => x.url == file.url)
      if (index > -1) {
        if (file.T == 0) {
          this[name].splice(index, 1)
        } else {
          this.removeImgs.push(this[name].splice(index, 1)[0])
        }
      }
    },
    onExceed() {
      this.$message.error('超过上传数量限制')
    },
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash ? this.urlHash.split('/').join('') : location.hash.split('/').slice(1).join('')
      this.formApi.list({ type: modeName }).then(res => {
        this.showList = res.Data?.map(x => x.ShowField)
      })
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true
      return this.showList.indexOf(data) !== -1 ? true : false
    },
    onCreateOpened() {
      this.api.getMaxSn().then(res => {
        this.data.Sn = res
      })
    },
    onEditOpened(data) {
      if (data.TrademarkPhoto) {
        var imgs = data.TrademarkPhoto.split(',')
        console.log(imgs,"imgs");
        imgs.forEach(item => {
          this.Imgs.push({
            url: '/api' + item,
            url2: item
          })
        })
        console.log(this.Imgs,"this.Imgs");
      }
    },
    onBeforeSave() {
      if (this.Imgs.length === 0) {
        this.data.TrademarkPhoto = ''
      } else {
        this.data.TrademarkPhoto = this.Imgs.map((item) => item.url2).toString(",")
      }
      console.log(this.data,"onbeforeSave");
    },
    onClosed() {
      this.showList = []
      this.Imgs = []
    }
  }
}
</script>